import { render } from "./ClienteCadastro.vue?vue&type=template&id=5788c1f8&scoped=true&ts=true"
import script from "./ClienteCadastro.vue?vue&type=script&lang=ts"
export * from "./ClienteCadastro.vue?vue&type=script&lang=ts"

import "./ClienteCadastro.vue?vue&type=style&index=0&id=5788c1f8&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5788c1f8"]])

export default __exports__